import script from "./RegisteredChild.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisteredChild.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__